import type { PaginatedResponse } from '@shared/types';
import { z } from 'zod';

export const $EducationLevel = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  category: z.string(),
  type: z.string(),
  description: z.string(),
});

export type EducationLevel = z.infer<typeof $EducationLevel>;

export type GetEducationLevelsResponse = PaginatedResponse<EducationLevel>;
